import { api } from './axios'
import type { ApiResponse } from '@/types'

export interface Plan {
  id: 'monthly' | 'semiannual' | 'annual'
  priceMonthly: number
  priceTotal: number
  currency: string
}

export interface PlanInfo {
  plans: Plan[]
  stripeEnabled: boolean
}

export interface CheckoutResponse {
  url: string
}

export interface BillingPortalResponse {
  url: string
}

export interface SubscriptionStatus {
  hasActiveSubscription: boolean
  status: string | null
  currentPeriodEnd: string | null
  daysRemaining: number | null
  billingMode: string | null
}

export const subscriptionService = {
  async getPlan(): Promise<PlanInfo> {
    const response = await api.get<ApiResponse<PlanInfo>>('/subscriptions/plan')
    return response.data.data
  },

  async createCheckout(
    successUrl: string,
    cancelUrl: string,
    interval: 'monthly' | 'semiannual' | 'annual'
  ): Promise<CheckoutResponse> {
    const response = await api.post<ApiResponse<CheckoutResponse>>('/subscriptions/checkout', {
      successUrl,
      cancelUrl,
      interval,
    })
    return response.data.data
  },

  async createBillingPortal(returnUrl: string): Promise<BillingPortalResponse> {
    const response = await api.post<ApiResponse<BillingPortalResponse>>(
      '/subscriptions/billing-portal',
      {
        returnUrl,
      }
    )
    return response.data.data
  },

  async getStatus(facilityId: string): Promise<SubscriptionStatus> {
    const response = await api.get<ApiResponse<SubscriptionStatus>>(
      `/subscriptions/facility/${facilityId}/status`
    )
    return response.data.data
  },
}
